var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"textarea-container",class:{ disabled: _vm.disabled }},[_vm._t("default"),_vm._t("bottom")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }